import type { FC } from 'react';
import React from 'react';
import { ModalDesktop as Modal } from '@alfa-bank/site-modal/desktop';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Aligner } from '@alfa-bank/site-aligner';
import { useDispatch, useSelector } from 'react-redux';

import type { TDispatch } from '../../store';
import { selectDeliveryAddressMetaState, setAddressValidationStatus } from '../../store';

// TODO временный костыль для отображения валидации
export const AddressValidationModalsDesktop: FC = () => {
    const deliveryAddressMetaState = useSelector(selectDeliveryAddressMetaState);
    const dispatch = useDispatch<TDispatch>();

    const handleCloseModal = () => {
        dispatch(setAddressValidationStatus('idle'));
    };

    const outOfRangeTitle = 'Указанный адрес не входит в зону доставки и самовывоза.';

    return (
        <>
            {deliveryAddressMetaState.addressValidationStatus === 'validationErrorOutOfRange' && (
                <Modal onClose={handleCloseModal} size="m">
                    <Aligner>
                        <Text styler={{ marginTop: 0, marginBottom: 24 }} view="medium">
                            {outOfRangeTitle}
                        </Text>
                        <Text styler={{ marginTop: 0, marginBottom: 24 }} view="primary-medium">
                            Попробуйте ввести другой адрес.
                        </Text>
                        <Button onClick={handleCloseModal} size="s" type="button" view="primary">
                            Продолжить
                        </Button>
                    </Aligner>
                </Modal>
            )}
            {deliveryAddressMetaState.addressValidationStatus === 'validationErrorCommon' && (
                <Modal onClose={handleCloseModal} size="m">
                    <Aligner>
                        <Text styler={{ marginTop: 0, marginBottom: 24 }} view="medium">
                            Адрес не найден
                        </Text>
                        <Text styler={{ marginTop: 0, marginBottom: 24 }} view="primary-medium">
                            Убедитесь, что указали верный адрес
                        </Text>
                        <Button onClick={handleCloseModal} size="s" type="button" view="primary">
                            Продолжить
                        </Button>
                    </Aligner>
                </Modal>
            )}
        </>
    );
};
